import { Link } from "react-router-dom";
import { nip19 } from "nostr-tools";
import { useAuthor } from "@/hooks/useAuthor";
import { getDisplayName } from "@/lib/getDisplayName";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

interface AuthorLineProps {
  pubkey: string;
  timestamp?: number;
}

export function AuthorLine({ pubkey, timestamp }: AuthorLineProps) {
  const author = useAuthor(pubkey);
  const metadata = author.data?.metadata;
  const name = getDisplayName(metadata, pubkey);
  const npub = nip19.npubEncode(pubkey);

  return (
    <div className="flex items-center gap-2 min-w-0">
      <Avatar className="h-7 w-7 shrink-0">
        <AvatarImage src={metadata?.picture} alt={name} />
        <AvatarFallback className="text-[10px]">
          {name.slice(0, 2).toUpperCase()}
        </AvatarFallback>
      </Avatar>
      <Link
        to={`/${npub}`}
        className="text-sm font-medium truncate hover:underline"
        title={npub}
      >
        {name === "Anonymous" ? `${npub.slice(0, 12)}…` : name}
      </Link>
      {timestamp ? (
        <span className="text-xs text-muted-foreground shrink-0">
          · {new Date(timestamp * 1000).toLocaleString()}
        </span>
      ) : null}
    </div>
  );
}
